import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import {
  Grid,
  ListItemText,
  Menu,
  Divider,
  Tooltip,
  alpha,
  useTheme,
} from "@mui/material";
import MenuItem from "@mui/material/MenuItem";
import MenuList from "@mui/material/MenuList";
import IconButton from "@mui/material/IconButton";
import CancelIcon from "@mui/icons-material/Cancel";
import Box from "@mui/material/Box";

interface CompareBtnProps {
  setAnchorTroubleshootEl: any;
  anchorTroubleshootEl: any;
  troubleShootMenuOpen: any;
  compareAssets: any;
  removeSelectedTag: any;
  compare: any;
  assetId?: string;
  asset?: any;
  parentAssetId?: string;
}
const CompareBtn = ({
  setAnchorTroubleshootEl,
  anchorTroubleshootEl,
  troubleShootMenuOpen,
  compareAssets,
  removeSelectedTag,
  compare,
  assetId,
  asset,
  parentAssetId,
}: CompareBtnProps) => {
  const theme = useTheme();
  return (
    <>
      <Button
        sx={{
          width: "auto",
          minWidth: 200, // Set width
          height: 35, // Set height (same as width for square)
          padding: " 0 10px", // Remove extra padding
          borderRadius: 1, // Optional: Adjust for rounded square look
          backgroundColor: alpha(theme.palette.primary.main, 0.3),
          color: "white", // Icon color
          "&:hover": {
            backgroundColor: "primary.dark", // Darker color on hover
          },
        }}
        variant="contained"
        onClick={(e: any) => setAnchorTroubleshootEl(e.currentTarget)}
      >
        Troubleshooting Module
      </Button>
      <Menu
        anchorEl={anchorTroubleshootEl}
        open={troubleShootMenuOpen}
        onClose={() => setAnchorTroubleshootEl(null)}
      >
        <MenuList
          style={{
            background: "#343D70",
            padding: "0px",
          }}
        >
          {compareAssets.map(({ title, key, color }: any) => (
            <MenuItem>
              <ListItemText>{title}</ListItemText>
              <Typography sx={{ ml: 3 }} variant="body2" color="text.secondary">
                <IconButton>
                  <CancelIcon
                    onClick={() => {
                      const splitData = title.split(" - ");
                      removeSelectedTag({
                        machineName: splitData[1] || "",
                        tag: key?.split("_")?.slice(0, -2)?.join("_"),
                        ASSET_COLOR: color,
                        parentAssetName: splitData[0],
                        kpi: `_${splitData.at(-1)}` || "",
                        assetId,
                        asset,
                        parentAssetId,
                      });
                    }}
                    style={{ color: "white" }}
                    fontSize="medium"
                  />
                </IconButton>
              </Typography>
            </MenuItem>
          ))}
        </MenuList>
        {!compareAssets?.length && <Box mb={2}>No KPIs Selected</Box>}
        <Divider />
        <Box sx={{ textAlign: "right", mt: 2 }}>
          <Tooltip
            title="Select Minimum 2 KPI's"
            placement="left"
            disableHoverListener={compareAssets?.length > 1}
          >
            <span>
              <Button
                onClick={compare}
                variant="contained"
                disabled={!compareAssets?.length || compareAssets?.length < 2}
              >
                Lets Compare
              </Button>
            </span>
          </Tooltip>
        </Box>
      </Menu>
    </>
  );
};

export default CompareBtn;




// import React from "react";
// import {
// 	Typography,
// 	Button,
// 	ListItemText,
// 	Menu,
// 	Divider,
// 	Tooltip,
// 	alpha,
// 	useTheme,
// 	MenuItem,
// 	MenuList,
// 	IconButton,
// 	Box,
// } from "@mui/material";
// import CancelIcon from "@mui/icons-material/Cancel";

// /**
//  * Props for the CompareBtn component.
//  */
// interface CompareBtnProps {
// 	setAnchorTroubleshootEl: (element: HTMLElement | null) => void;
// 	anchorTroubleshootEl: HTMLElement | null;
// 	troubleShootMenuOpen: boolean;
// 	compareAssets: Array<{
// 		title: string;
// 		key: string;
// 		color: string;
// 	}>;
// 	removeSelectedTag: (params: {
// 		machineName: string;
// 		tag: string;
// 		ASSET_COLOR: string;
// 		parentAssetName: string;
// 		kpi: string;
// 	}) => void;
// 	compare: () => void;
// }

// /**
//  * CompareBtn Component
//  * 
//  * This component renders a button that opens a troubleshooting menu. The menu allows users
//  * to view selected KPIs, remove them, and compare them if at least two KPIs are selected.
//  * 
//  * @param {CompareBtnProps} props - The props for the component.
//  * @returns {JSX.Element} The rendered CompareBtn component.
//  */
// const CompareBtn: React.FC<CompareBtnProps> = ({
// 	setAnchorTroubleshootEl,
// 	anchorTroubleshootEl,
// 	troubleShootMenuOpen,
// 	compareAssets,
// 	removeSelectedTag,
// 	compare,
// }) => {
// 	const theme = useTheme();

// 	return (
// 		<>
// 			{/* Troubleshooting Button */}
// 			<Button
// 				sx={{
// 					width: "auto",
// 					minWidth: 200,
// 					height: 35,
// 					padding: "0 10px",
// 					borderRadius: 1,
// 					backgroundColor: alpha(theme.palette.primary.main, 0.3),
// 					color: "white",
// 					"&:hover": {
// 						backgroundColor: theme.palette.primary.dark,
// 					},
// 				}}
// 				variant="contained"
// 				onClick={(e) => setAnchorTroubleshootEl(e.currentTarget)}
// 			>
// 				Troubleshooting Module
// 			</Button>

// 			{/* Troubleshooting Menu */}
// 			<Menu
// 				anchorEl={anchorTroubleshootEl}
// 				open={troubleShootMenuOpen}
// 				onClose={() => setAnchorTroubleshootEl(null)}
// 			>
// 				<MenuList
// 					sx={{
// 						backgroundColor: "#343D70",
// 						padding: 0,
// 					}}
// 				>
// 					{/* List of Selected KPIs */}
// 					{compareAssets.map(({ title, key, color }) => (
// 						<MenuItem key={key}>
// 							<ListItemText>{title}</ListItemText>
// 							<Typography sx={{ ml: 3 }} variant="body2" color="text.secondary">
// 								<IconButton
// 									onClick={() => {
// 										const splitData = title.split(" - ");
// 										removeSelectedTag({
// 											machineName: splitData[1] || "",
// 											tag: key.split("_").slice(0, -2).join("_"),
// 											ASSET_COLOR: color,
// 											parentAssetName: splitData[0],
// 											kpi: `_${splitData.at(-1)}` || "",
// 										});
// 									}}
// 									sx={{ color: "white" }}
// 								>
// 									<CancelIcon fontSize="medium" />
// 								</IconButton>
// 							</Typography>
// 						</MenuItem>
// 					))}
// 				</MenuList>

// 				{/* No KPIs Selected Message */}
// 				{!compareAssets.length && (
// 					<Box mb={2} sx={{ textAlign: "center", color: "white" }}>
// 						No KPIs Selected
// 					</Box>
// 				)}

// 				<Divider />

// 				{/* Compare Button */}
// 				<Box sx={{ textAlign: "right", mt: 2 }}>
// 					<Tooltip
// 						title="Select Minimum 2 KPIs"
// 						placement="left"
// 						disableHoverListener={compareAssets.length > 1}
// 					>
// 						<span>
// 							<Button
// 								onClick={compare}
// 								variant="contained"
// 								disabled={compareAssets.length < 2}
// 							>
// 								Let's Compare
// 							</Button>
// 						</span>
// 					</Tooltip>
// 				</Box>
// 			</Menu>
// 		</>
// 	);
// };

// export default CompareBtn;

